(function() {
  var finder = document.querySelector('.m-shoe-finder');
  if (!finder) return;

  var answers = {};
  var currentStep = 0;
  var steps = finder.querySelectorAll('.m-shoe-finder__step');
  var totalSteps = steps.length;
  var progressFill = finder.querySelector('.m-shoe-finder__progress-fill');
  var progressText = finder.querySelector('.m-shoe-finder__progress-text');
  var resultsEl = finder.querySelector('.m-shoe-finder__results');
  var resultsGrid = finder.querySelector('.m-shoe-finder__results-grid');
  var stepsContainer = finder.querySelector('.m-shoe-finder__steps');

  function updateProgress() {
    var pct = ((currentStep) / totalSteps) * 100;
    if (progressFill) progressFill.style.width = pct + '%';
    if (progressText) progressText.textContent = 'Étape ' + (currentStep + 1) + ' sur ' + totalSteps;
  }

  function showStep(idx) {
    steps.forEach(function(s) { s.classList.remove('is-active'); });
    if (steps[idx]) {
      steps[idx].classList.remove('is-active');
      // Force reflow for animation
      void steps[idx].offsetWidth;
      steps[idx].classList.add('is-active');
    }
    currentStep = idx;
    updateProgress();
  }

  function nextStep() {
    if (currentStep + 1 < totalSteps) {
      showStep(currentStep + 1);
    } else {
      showResults();
    }
  }

  function prevStep() {
    if (currentStep > 0) {
      showStep(currentStep - 1);
    }
  }

  // Option click (single select, auto-advance)
  finder.querySelectorAll('[data-sf-option]').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var step = this.closest('.m-shoe-finder__step');
      var key = step.dataset.sfKey;
      var value = this.dataset.sfOption;

      // Single select
      step.querySelectorAll('[data-sf-option]').forEach(function(b) { b.classList.remove('is-selected'); });
      this.classList.add('is-selected');

      answers[key] = value;

      // Auto-advance after short delay
      setTimeout(nextStep, 250);
    });
  });

  // Size click
  finder.querySelectorAll('[data-sf-size]').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var step = this.closest('.m-shoe-finder__step');
      finder.querySelectorAll('[data-sf-size]').forEach(function(b) { b.classList.remove('is-selected'); });
      this.classList.add('is-selected');
      answers.size = this.dataset.sfSize;
      setTimeout(nextStep, 250);
    });
  });

  // Brand click (multi-select with manual advance)
  finder.querySelectorAll('[data-sf-brand]').forEach(function(btn) {
    btn.addEventListener('click', function() {
      this.classList.toggle('is-selected');
      var selected = [];
      finder.querySelectorAll('[data-sf-brand].is-selected').forEach(function(b) {
        selected.push(b.dataset.sfBrand);
      });
      answers.brands = selected;
    });
  });

  // Back buttons
  finder.querySelectorAll('[data-sf-back]').forEach(function(btn) {
    btn.addEventListener('click', prevStep);
  });

  // Skip buttons
  finder.querySelectorAll('[data-sf-skip]').forEach(function(btn) {
    btn.addEventListener('click', nextStep);
  });

  // Next button (for brand step)
  finder.querySelectorAll('[data-sf-next]').forEach(function(btn) {
    btn.addEventListener('click', nextStep);
  });

  // Restart
  finder.querySelectorAll('[data-sf-restart]').forEach(function(btn) {
    btn.addEventListener('click', function() {
      answers = {};
      finder.querySelectorAll('.is-selected').forEach(function(el) { el.classList.remove('is-selected'); });
      resultsEl.classList.remove('is-visible');
      stepsContainer.style.display = '';
      finder.querySelector('.m-shoe-finder__progress').style.display = '';
      showStep(0);
    });
  });

  // ===== Brand mapping (fallback when products have no tags) =====
  var BRAND_MAP = {
    'adidas':       { occasion: ['casual', 'sport'],  style: ['streetwear', 'sporty', 'tendance'] },
    'armistice':    { occasion: ['casual'],            style: ['classique', 'tendance'] },
    'birkenstock':  { occasion: ['casual'],            style: ['classique'] },
    'clarks':       { occasion: ['travail', 'casual'], style: ['classique'] },
    'converse':     { occasion: ['casual', 'soiree'],  style: ['streetwear', 'classique'] },
    'dr.martens':   { occasion: ['casual', 'soiree'],  style: ['classique', 'tendance'] },
    'new balance':  { occasion: ['casual'],            style: ['streetwear', 'tendance'] },
    'no name':      { occasion: ['casual'],            style: ['tendance', 'classique'] },
    'on running':   { occasion: ['sport', 'casual'],   style: ['sporty', 'tendance'] },
    'reebok':       { occasion: ['casual', 'sport'],   style: ['sporty', 'streetwear'] },
    'schmoove':     { occasion: ['casual', 'travail'], style: ['classique', 'tendance'] },
    'timberland':   { occasion: ['outdoor', 'casual'], style: ['classique'] },
    'vans':         { occasion: ['casual', 'skate'],   style: ['streetwear'] },
    'veja':         { occasion: ['casual'],            style: ['tendance', 'classique'] }
  };

  // Color keywords mapping
  var COLOR_MAP = {
    'neutre': ['black', 'noir', 'white', 'blanc', 'grey', 'gris', 'gray', 'silver', 'charcoal'],
    'terre':  ['brown', 'marron', 'beige', 'tan', 'kaki', 'khaki', 'olive', 'sand', 'wheat', 'taupe', 'cream', 'camel'],
    'colore': ['red', 'rouge', 'blue', 'bleu', 'green', 'vert', 'yellow', 'jaune', 'orange', 'pink', 'rose', 'purple', 'violet', 'navy', 'coral', 'turquoise', 'teal']
  };

  function getProductTraits(p) {
    var vendor = (p.vendor || '').toLowerCase();
    var tags = (p.tags || []).map(function(t) { return t.toLowerCase().trim(); });
    var title = (p.title || '').toLowerCase();
    var brandData = BRAND_MAP[vendor] || { occasion: [], style: [] };

    // Occasion: prefer tags, fallback to brand mapping
    var occasions = tags.filter(function(t) {
      return ['casual', 'sport', 'soiree', 'travail', 'outdoor', 'skate'].includes(t);
    });
    if (occasions.length === 0) occasions = brandData.occasion;

    // Style: prefer tags, fallback to brand mapping
    var styles = tags.filter(function(t) {
      return ['streetwear', 'classique', 'sporty', 'tendance'].includes(t);
    });
    if (styles.length === 0) styles = brandData.style;

    // Color: check title and tags for color keywords
    var colors = [];
    for (var colorGroup in COLOR_MAP) {
      var keywords = COLOR_MAP[colorGroup];
      var hasColor = keywords.some(function(kw) {
        return title.includes(kw) || tags.some(function(t) { return t.includes(kw); });
      });
      if (hasColor) colors.push(colorGroup);
    }

    return { occasions: occasions, styles: styles, colors: colors, tags: tags };
  }

  // ===== Results =====
  function formatMoney(price) {
    return parseFloat(price).toFixed(2).replace('.', ',') + ' €';
  }

  async function showResults() {
    stepsContainer.style.display = 'none';
    finder.querySelector('.m-shoe-finder__progress').style.display = 'none';
    resultsGrid.innerHTML = '<div class="m-shoe-finder__loading">Recherche de tes paires idéales...</div>';
    resultsEl.classList.add('is-visible');

    // Fetch products
    var allProducts = [];
    var page = 1;
    var hasMore = true;

    while (hasMore && page <= 10) {
      try {
        var resp = await fetch('/collections/all/products.json?limit=50&page=' + page);
        var data = await resp.json();
        if (data.products && data.products.length) {
          allProducts = allProducts.concat(data.products);
          if (data.products.length < 50) hasMore = false;
          page++;
        } else {
          hasMore = false;
        }
      } catch(e) {
        hasMore = false;
      }
    }

    // Score and filter
    var scored = [];

    allProducts.forEach(function(p) {
      // Must have image
      if (!p.images || !p.images.length) return;
      // Must be available
      if (!p.variants.some(function(v) { return v.available; })) return;

      var vendor = (p.vendor || '').toLowerCase();
      var traits = getProductTraits(p);
      var score = 0;
      var excluded = false;

      // Gender (hard filter)
      if (answers.gender === 'homme') {
        if (traits.tags.includes('femme') && !traits.tags.includes('homme') && !traits.tags.includes('unisexe') && !traits.tags.includes('unisex')) {
          excluded = true;
        }
        if (traits.tags.includes('homme') || traits.tags.includes('unisexe') || traits.tags.includes('unisex')) score += 3;
      }
      if (answers.gender === 'femme') {
        if (traits.tags.includes('homme') && !traits.tags.includes('femme') && !traits.tags.includes('unisexe') && !traits.tags.includes('unisex')) {
          excluded = true;
        }
        if (traits.tags.includes('femme') || traits.tags.includes('unisexe') || traits.tags.includes('unisex')) score += 3;
      }
      if (excluded) return;

      // Budget (hard filter)
      var price = parseFloat(p.variants[0].price);
      if (answers.budget) {
        var minP = 0, maxP = 99999;
        if (answers.budget === 'under80') maxP = 80;
        if (answers.budget === '80to120') { minP = 80; maxP = 120; }
        if (answers.budget === '120to180') { minP = 120; maxP = 180; }
        if (answers.budget === 'over180') minP = 180;
        if (price < minP || price > maxP) return;
      }

      // Brand (hard filter)
      if (answers.brands && answers.brands.length > 0 && !answers.brands.includes('any')) {
        if (!answers.brands.some(function(b) { return vendor === b.toLowerCase(); })) return;
      }

      // Size (hard filter)
      if (answers.size) {
        var sizeAvailable = p.variants.some(function(v) {
          return v.available && v.title === answers.size;
        });
        if (!sizeAvailable) return;
      }

      // Occasion (scoring)
      if (answers.occasion) {
        if (traits.occasions.includes(answers.occasion)) score += 5;
      }

      // Style (scoring)
      if (answers.style) {
        if (traits.styles.includes(answers.style)) score += 4;
      }

      // Color (scoring)
      if (answers.color && answers.color !== 'any') {
        if (traits.colors.includes(answers.color)) score += 3;
      }

      scored.push({ product: p, score: score });
    });

    // Sort by score descending, then randomize within same score
    scored.sort(function(a, b) {
      if (b.score !== a.score) return b.score - a.score;
      return Math.random() - 0.5;
    });

    // Take top 6
    var results = scored.slice(0, 6).map(function(s) { return s.product; });

    // Render
    resultsGrid.innerHTML = '';

    if (results.length === 0) {
      resultsGrid.innerHTML = '<div class="m-shoe-finder__loading" style="grid-column: 1/-1;">Aucun produit ne correspond à tes critères. Essaie avec moins de filtres !</div>';
      return;
    }

    results.forEach(function(p) {
      var img = p.images[0] ? p.images[0].src : '';
      var variant = p.variants[0];
      var hasCompare = variant.compare_at_price && parseFloat(variant.compare_at_price) > parseFloat(variant.price);

      var priceHTML = '';
      if (hasCompare) {
        priceHTML = '<span class="m-shoe-finder__result-price--compare">' + formatMoney(variant.compare_at_price) + '</span><span class="m-shoe-finder__result-price--sale">' + formatMoney(variant.price) + '</span>';
      } else {
        priceHTML = formatMoney(variant.price);
      }

      var card = document.createElement('a');
      card.href = '/products/' + p.handle;
      card.className = 'm-shoe-finder__result-card';
      card.innerHTML =
        '<div class="m-shoe-finder__result-img"><img src="' + img + '" alt="' + p.title + '" loading="lazy"></div>' +
        '<div class="m-shoe-finder__result-info">' +
          '<p class="m-shoe-finder__result-brand">' + (p.vendor || '') + '</p>' +
          '<h3 class="m-shoe-finder__result-name">' + p.title + '</h3>' +
          '<div class="m-shoe-finder__result-price">' + priceHTML + '</div>' +
        '</div>';
      resultsGrid.appendChild(card);
    });
  }

  // Init
  showStep(0);
})();
